import React, { useState } from "react";
import "./question.css";
import { useTranslation, Trans } from "react-i18next";
export default function StarterQuestions({ onCancelQuestions, onForward }) {
    const { t } = useTranslation("clientBooking");
    const [error, setError] = useState(false);
    const [checkall, setCheckAll] = useState(false);



    // const changeHandler = (e, setCheck, type) => {
    //     if (type === "radio") {
    //         setCheckYes(e.target.value);
    //     } else {
    //         setCheck(e.target.checked);
    //     }
    // };
    const changeHandlerAll = (e) => {
        setCheckAll(e.target.checked);
    }
    const onClickHandler = () => {
        if (checkall) {
            onForward()
        }
        else {
            setError(true);
        }
    }
    return (
        <div class="container-fluid question-container">
            <div class="row justify-content-center">
                <div class="col-11 col-sm-10 col-md-10 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
                    <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
                        <form id="msform">

                            <fieldset>
                                <div class="form-card">
                                    <div class="row wrap">
                                        <h2 className="text-center">{t("terms.readConfirm")}</h2>
                                        <div class="new margin-unset">
                                            <div class="form-group">
                                                <input
                                                    onChange={(e) => {
                                                        changeHandlerAll(e);
                                                    }}
                                                    checked={checkall}
                                                    name="checkall"
                                                    type="checkbox"
                                                    id="checkall"
                                                />
                                                <label htmlFor="checkall">{t("starterTerms.agreeToAll")}</label>
                                            </div>
                                        </div>
                                        <h2>{t("starterTerms.iUnderstand")}</h2>
                                        <div class="new margin-unset">
                                            <div>
                                               
                                                <ul>
                                                    <li className="starter-label">
                                                        {t("starterTerms.understand1")}</li>
                                                    <li className="starter-label">{t("starterTerms.understand2")}</li>
                                                    <li className="starter-label">{t("starterTerms.understand3")}</li>
                                                </ul>

                                            </div>

                                            <h2>{t("terms.iWill")}</h2>
                                            <div >
                                                <ul>
                                                    <li className="starter-label">
                                                        <Trans i18nKey="starterTerms.will1" ns="clientBooking" components={{ u: <span className="text-underline" /> }} /></li>
                                                    <li className="starter-label">{t("starterTerms.will2")}</li>
                                                    <li className="starter-label">{t("starterTerms.will3")}</li>
                                                    <li className="starter-label">{t("starterTerms.will4")}</li>
                                                    <li className="starter-label"><Trans i18nKey="starterTerms.will5" ns="clientBooking" components={{ u: <span className="text-underline" /> }} /></li>
                                                    <li className="starter-label">{t("starterTerms.will6")}</li>

                                                </ul>
                                            </div>

                                            {/*****In understabd */}
                                            <h2>{t("terms.iUnderstandThat")}</h2>
                                            <div >
                                                <ul>
                                                    <li className="starter-label">
                                                        {t("starterTerms.that1")}
                                                    </li>
                                                    <li className="starter-label">{t("starterTerms.that2")}</li>
                                                    <li className="starter-label">{t("starterTerms.will3")}</li>
                                                    <li className="starter-label">{t("starterTerms.that4")}</li>
                                                    <li className="starter-label">{t("starterTerms.that5")}</li>
                                                    <li className="starter-label">{t("starterTerms.will6")}</li>

                                                </ul>
                                            </div>


                                            {error && (
                                                    <div>
                                                        <p className="red">
                                                            {t("terms.selectAll")}
                                                        </p>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <input
                                    onClick={onCancelQuestions}
                                    type="button"
                                    name="previous"
                                    class="previous action-button-previous"
                                    value={t("buttons.cancel")}
                                />
                                <input
                                    onClick={onClickHandler}
                                    type="button"
                                    name="next"
                                    class="next action-button"
                                    value={t("buttons.next")}
                                />
                            </fieldset>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
